import type { UserKind } from 'common/enums/user-kind.enum';
import BaseChangeset from 'common/changesets/base';
import type ActionModel from 'frontend/models/action';

export interface CommonApplicantDTO {
  id?: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
}

export interface UnemployedApplicantDTO extends CommonApplicantDTO {
  registerNumber?: string;
}

export interface CompanyApplicantDTO extends CommonApplicantDTO {
  companyNumber?: string;
  companyName?: string;
}

export interface TeacherApplicantDTO extends CommonApplicantDTO {
  institution?: string;
  cooperationAgreement?: boolean;
}

export type ApplicationDTO = {
  id?: string;
  action: ActionModel;
  kind: UserKind | undefined;
  newsAgreement: boolean;
  privacyPolicyAgreement: boolean;
  termsAgreement: boolean;
  applicant: CompanyApplicantDTO & UnemployedApplicantDTO & TeacherApplicantDTO;
};

export class ApplicationChangeset extends BaseChangeset<ApplicationDTO> {}
